import { useState } from 'react';
import styles from '../../ApplicationInformation.module.scss';
import BulkSelectModal from '../../../../components/UI/BulkSelectModal/BulkSelectModal';
import classNames from 'classnames';

const LocationsEdit = ({ copyOfApp, setCopyOfApp, locationOptions }) => {
	const [locationData, setLocationData] = useState([
		...copyOfApp.appInfo.locations.locationData,
	]);

	const initialSelectedOptions = [
		...copyOfApp.appInfo.locations.locationData,
	];

	const formattedOptions = locationOptions.map(x => {
		return { ID: x.ID, Name: x.FullName };
	});

	const setAppLocations = () => {
		let updatedApp = { ...copyOfApp };
		updatedApp.appInfo.locations.locationData = locationData;
		updatedApp.appInfo.locations.displayFormattedLocations = locationData
			.map(x => {
				return x.Name;
			})
			.join(', ');
		setCopyOfApp(updatedApp);
	};

	const handleChange = updatedLocations => {
		setLocationData(updatedLocations);
	};

	return (
		<div className={classNames([styles.hFull, styles.detailInfo])}>
			<div className={styles.locationsEdit}>
				<BulkSelectModal
					options={formattedOptions}
					onChange={handleChange}
					onDone={setAppLocations}
					selected={locationData}
					initialSelections={initialSelectedOptions}
					optionLabelKey={'Name'}
					buttonLabel='Edit Locations'
				/>
				<p className={styles.margin_top}>
					{copyOfApp.appInfo.locations.displayFormattedLocations}
				</p>
			</div>
		</div>
	);
};

export default LocationsEdit;
